import { ErpAdditionalMessageDto } from './../../../common/model/erpadditionalmessagedto';
import { JobAdvertisementService } from 'app/rm/erp/jobadvertisement/service/jobadvertisement.service';
import { Component, Input, OnInit } from '@angular/core';
import { JobApplication } from '../../model/jobapplication';
import { HisUiService } from 'hisng';
import { JobAdvertisement } from 'app/rm/erp/jobadvertisement/model/jobadvertisement';

@Component( {
    selector: 'erp-jobapplication-success',
    templateUrl: './jobapplication-success.component.html',
} )
export class JobApplicationSuccessComponent implements OnInit {

    @Input() jobApplicationDto: ErpAdditionalMessageDto<JobApplication> = { dto: new JobApplication(), message: '' };
    jobAdvertisement: JobAdvertisement = new JobAdvertisement();

    constructor(
        private readonly jobAdvertisementService: JobAdvertisementService,
        private readonly hisUiService: HisUiService
    ) { }

    ngOnInit() {
        if ( this.jobApplicationDto.dto.jobAdvertisementId ) {
            this.jobAdvertisementService.getById( this.jobApplicationDto.dto.jobAdvertisementId )
                .subscribe( ad => this.jobAdvertisement = ad );
        }
    }

    getSuccessBodyText(): string {
        if ( this.jobAdvertisement.shortDescription ) {
            if ( this.jobApplicationDto.dto.id ) {
                return this.hisUiService.translate( 'rm.erp.jobapplication.success.body', this.jobAdvertisement.shortDescription,
                    this.jobApplicationDto.dto.id );
            }
            else {
                return this.hisUiService.translate( 'rm.erp.jobapplication.success.body.error' );
            }
        } else {
            if ( this.jobApplicationDto.dto.id ) {
                return this.hisUiService.translate( 'rm.erp.jobapplication.success.body.nodescription', this.jobApplicationDto.dto.id );
            } else {
                return this.hisUiService.translate( 'rm.erp.jobapplication.success.body.error' );
            }
        }
    }
}
